import { render, staticRenderFns } from "./RankingIndex.vue?vue&type=template&id=2b27e33b&scoped=true"
import script from "./RankingIndex.vue?vue&type=script&lang=js"
export * from "./RankingIndex.vue?vue&type=script&lang=js"
import style0 from "./RankingIndex.vue?vue&type=style&index=0&id=2b27e33b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27e33b",
  null
  
)

export default component.exports